<div mat-dialog-title>
  <div class="modal__header">
    <div class="modal__title">
      <h1>Create {{ 'deliverable' | lang }} Entry</h1>
    </div>

    <button
      class="close-button"
      mat-dialog-close>
      <mat-icon class="material-symbols-rounded">close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content
  aria-label="Generic modal"
  class="modal-container md-dialog-container generic-modal">
  <div class="px-10 pb-4 w-full generic-modal__content">
    <div class="flex-row">
      <scope-ui-autocomplete
        label="Choose Rate Card"
        [control]="getControl('rateCard')"
        [options]="rateCards$ | async" />
    </div>

    <div class="flex-row pt-8">
      <scope-ui-autocomplete
        label="Choose Discipline"
        [control]="getControl('discipline')"
        [options]="disciplines$ | async" />
    </div>

    <div class="flex-row pt-8">
      <description-editor
        class="px-10"
        status="DRAFT"
        [showNoteBelow]="true"
        [descriptionRequired]="true"
        [descriptionDirty]="getControl('description').touched"
        [model]="{ description: getControlValue('description') }"
        (onSaveDescription)="setControlValue('description', $event)"
        (onSaveNote)="setControlValue('internalNote', $event)" />
    </div>

    <div
      *ngIf="data.deliverable.fixedPricing"
      class="flex-row pt-8">
      <scope-ui-toggle
        title="Fixed Fee is editable"
        [initialValue]="true"
        [control]="getControl('fixedCostEditable')">
      </scope-ui-toggle>
    </div>
  </div>

  <div class="d-flex d-flex-justify-end px-10 pt-8 pb-4">
    <div class="generic-modal__buttons">
      <button
        mat-button
        mat-dialog-close>
        Cancel
      </button>
      <button
        class="main-action-button ml-4"
        [class.disabled]="!modalForm.valid"
        mat-button
        (click)="submit()">
        Start {{ 'deliverable' | lang }} Builder
      </button>
    </div>
  </div>
</mat-dialog-content>
